module.exports = __webpack_public_path__ + "img/embedded-icon.f4241763.svg";